import React from 'react';
import { useIntl } from 'react-intl';
import { getMessageValue } from '../i18n/messageUtil.mjs';
import PropTypes from 'prop-types';

const MessageIfPresent = (props) => {
  const {
    id,
    children
  } = props;

  const intl = useIntl();

  return getMessageValue(intl.locale, id) ? <>{ children }</> : null;
};

MessageIfPresent.propTypes = {
  id: PropTypes.string,
  children: PropTypes.any
};

export default MessageIfPresent;
